import React from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-scroll";
import EdButton from "../edbutton/edButton";
import rejected from "../../../assets/images/generic/rejected.svg";
import recieved from "../../../assets/images/generic/recieved.svg";
import { ITOCScreenStateEnum } from "@frameworks/web/components/features/TOC/constant";
import { useSelector } from "react-redux";
import { isEqual } from "underscore";
import { addCommasWithConditionalDecimal } from "@domains/utils/numberMethods";
const OrderMsg = (props) => {
    var _a, _b;
    const { errorData: placeNormalTradeError } = useSelector((state) => state.TOCJourney.placeNormalTrade, isEqual);
    const handleMessage = () => {
        var _a;
        switch (props === null || props === void 0 ? void 0 : props.state) {
            case ITOCScreenStateEnum.REJECTED_ORDER:
                return (React.createElement(Col, { lg: 12, className: "d-flex justify-content-center mgt-20" },
                    React.createElement("span", { className: "DMSanN_16_400 text-center rejectedmsg" }, (_a = placeNormalTradeError === null || placeNormalTradeError === void 0 ? void 0 : placeNormalTradeError.error) === null || _a === void 0 ? void 0 : _a.getErrorMessageOrErrMsg())));
            case ITOCScreenStateEnum.INSUFFICIENT_FUND:
                return (React.createElement(Col, { lg: 12, className: "d-flex justify-content-center mgt-20" },
                    React.createElement("span", { className: "DMSanN_16_400 text-center rejectedmsg" },
                        "Order Rejected due to insufficient Funds ",
                        React.createElement("br", null),
                        "Add",
                        React.createElement("strong", null,
                            " ",
                            "\u20B9 ",
                            addCommasWithConditionalDecimal(props === null || props === void 0 ? void 0 : props.sortFunds)),
                        " ",
                        "funds to execute this order")));
            case ITOCScreenStateEnum.SUCCESS_ORDER:
                return React.createElement(React.Fragment, null);
            default:
                return React.createElement(React.Fragment, null);
        }
    };
    React.useEffect(() => {
        handleMessage();
    }, [props === null || props === void 0 ? void 0 : props.state, placeNormalTradeError]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `ordermsgsection  ${props.parentClass}` },
            React.createElement(Row, { className: "innersection mx-0" },
                React.createElement(Col, { lg: 12, className: "d-flex justify-content-center " },
                    React.createElement("span", { className: `EncodeSansN_20_400 ${props.status ? "recieved" : "rejected"}` }, props.title)),
                React.createElement(Col, { lg: 12, className: "d-flex justify-content-center mgt-10" },
                    React.createElement("img", { src: props.status ? recieved : rejected })),
                React.createElement(Col, { lg: 12, className: "d-flex justify-content-center mgt-36" },
                    React.createElement("div", { className: "orderbox" },
                        React.createElement("span", { className: `DMSansMedium_20_500  ${props.status ? "recieved" : "rejected"}` }, props === null || props === void 0 ? void 0 : props.tradeValue),
                        React.createElement("span", { className: "DMSans_16_500 mgt-10" }, (_b = (_a = props.multiQuote) === null || _a === void 0 ? void 0 : _a.quotesDetailsEntity[0]) === null || _b === void 0 ? void 0 : _b.tradeSymbol),
                        React.createElement(Link, { to: "/", onClick: () => { }, className: "addtowatchlist DMSans_16_500" }, "+ Add to Watchlist"))),
                handleMessage(),
                React.createElement(Col, { lg: 12, className: `d-flex justify-content-center mgt-30 ${props.parentbuttonClass}` },
                    React.createElement(EdButton, Object.assign({ className: "" }, props.btnvalueleft)),
                    !props.hideRightBtn && (React.createElement(EdButton, Object.assign({ className: "ms-4" }, props.btnvalueright))))))));
};
export default OrderMsg;
